export default __webpack_public_path__ + "static/header-marketing-c19593edfab6eaaf76635b2e5018f1ba.png";